export default __webpack_public_path__ + "alberta-ambulant.ef49c5c248d8ae4208cb.svg";